import { Component, Input, OnInit } from "@angular/core";
import Swal from "sweetalert2";
import { DocumentoGlobal } from "../documento/documento-global";
import { ParametrosGeraisService } from "../parametros-gerais/parametros-gerais.service";
import { CandidatoService } from "./../candidato/candidato.service";

@Component({
  selector: "app-upload",
  templateUrl: "./app-upload.component.html",
  styleUrls: ["./app-upload.component.css"],
})
export class AppUploadComponent implements OnInit {
  @Input() documento: any;
  @Input() idArquivo: number;
  @Input() link: string;
  @Input() classe: string;

  protected tamanhoLimite: number;
  protected extensoesAceitas: string[];
  protected mensagemErroArquivoTamanho: string;
  protected mensagemErroArquivoExtensao: string;

  constructor(
    private DocumentoGlobal: DocumentoGlobal,
    private CandidatoService: CandidatoService,
    private ParametrosGeraisService: ParametrosGeraisService
  ) {}

  async ngOnInit() {
    (await this.ParametrosGeraisService.getArquivoTamanhoLimite()).subscribe(
      (tamanho) => {
        this.tamanhoLimite = Number(tamanho);
      }
    );

    (await this.ParametrosGeraisService.getArquivoExtensoesAceitas()).subscribe(
      (extensoesAceitas: any) => {
        this.extensoesAceitas = extensoesAceitas;
      }
    );

    (
      await this.ParametrosGeraisService.getMensagemErroArquivoTamanho()
    ).subscribe((mensagemErro) => {
      this.mensagemErroArquivoTamanho = mensagemErro;
    });

    (
      await this.ParametrosGeraisService.getMensagemErroArquivoExtensao()
    ).subscribe((mensagemErro) => {
      this.mensagemErroArquivoExtensao = mensagemErro;
    });
  }

  getStatus() {
    let status = false;

    if (this.link) {
      status = true;
    }

    this.documento.DocCaminho.forEach((caminho) => {
      if (
        caminho.caminhoDocItem &&
        caminho.caminhoDocItem !== "" &&
        this.validaId(caminho)
      ) {
        status = true;
      }
    });

    return status;
  }

  checkPrcTipEnt() {
    let PrcTipEnt = false;

    this.documento.DocCaminho.forEach((caminho) => {
      if (
        caminho.PrcTipEnt === "U" ||
        (caminho.PrcTipEnt === "C" && this.validaId(caminho))
      ) {
        PrcTipEnt = true;
      }
    });

    return PrcTipEnt;
  }

  validaId(caminho) {
    return this.idArquivo == caminho.VPesDocIdArquivo;
  }

  getExtensao() {
    let extensao = "";

    this.documento.DocCaminho.forEach((caminho) => {
      if (caminho.ExtensaoArq && this.validaId(caminho)) {
        extensao = caminho.ExtensaoArq;
      }
    });

    if (extensao) {
      return extensao;
    }

    if (this.link) {
      return this.link.split(".").pop();
    }
  }

  getPrcTipEnt() {
    let PrcTipEnt = "";

    this.documento.DocCaminho.forEach((caminho) => {
      if (this.validaId(caminho)) {
        PrcTipEnt = caminho.PrcTipEnt;
      }
    });

    return PrcTipEnt;
  }

  arquivoChange(e) {
	if(!e.target.files[0]) {
		return false;
	}

    this.CandidatoService.setChangeDocumentos(true);

    const extensao = e.target.files[0].name.split(".").pop();
    const tamanhoEmMB = e.target.files[0].size / 1e6;

    if (!this.verificaArquivoExtensaoValida(extensao)) {
      this.showAlertExtensao();
      return false;
    }

    if (!this.verificaArquivoTamanhoValido(tamanhoEmMB)) {
      this.showAlertTamanhoInvalido();
      return false;
    }

    const fileReader = new FileReader();

    fileReader.readAsDataURL(e.target.files[0]);

    fileReader.onload = (event: any) => {
      this.link = event.target.result;
      this.setImagem(event.target.result, extensao);
      this.DocumentoGlobal.adicionaImagem(this.documento);
    };
  }

  setImagem(imagem, extensao) {
    this.documento.DocCaminho.forEach((caminho) => {
      if (this.validaId(caminho)) {
        caminho.caminhoDocItem = imagem;
        caminho.ExtensaoArq = extensao;
      }
    });
  }

  openLink() {
    const regex =
      /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

    if (regex.test(this.link)) {
      window.open(this.link, "_blank");
    } else {
      const base = this.link.split(",")[0];
      const w = window.open("");

      if (base.match("pdf")) {
        w.document.write(
          '<embed height="100%" width="100%" src="' + this.link + '"></embed>'
        );
      } else {
        w.document.write("<img src=" + this.link + ">");
      }
    }
  }

  getImagemDefault() {
    switch (this.documento.TipDocCod) {
      case this.DocumentoGlobal.getTipoRg():
        return this.getDocCaminhoRG();
      case this.DocumentoGlobal.getTipoDiploma():
        return "assets/images/diploma.png";
      case this.DocumentoGlobal.getTipoHistorico():
        return "assets/images/historico.png";
      default:
        return "assets/images/upload.png";
    }
  }

  getDocCaminhoRG() {
    let imagem = "";

    if (this.documento.DocCaminho.length == 2) {
      this.documento.DocCaminho.forEach((caminho, index) => {
        if (this.validaId(caminho) && index == 0) {
          imagem = "assets/images/rg_frente.png";
        }
        if (this.validaId(caminho) && index == 1) {
          imagem = "assets/images/rg_verso.png";
        }
      });
    } else {
      imagem = "assets/images/rg_cnh.png";
    }
    return imagem;
  }

  getFormaEnvio() {
    if (this.getPrcTipEnt() == "U") {
      return "Você escolheu entregar na Univali";
    } else {
      return "Você escolheu enviar pelos Correios";
    }
  }

  verificaArquivoExtensaoValida(extensao) {
    const extensaoDoArquivoValidada = this.extensoesAceitas.filter(
      (extensaoAceita) => extensao === extensaoAceita
    );

    const extensaoValida = Boolean(extensaoDoArquivoValidada.length);
	
    return extensaoValida;
  }

  verificaArquivoTamanhoValido(tamanhoEmMB) {
    return tamanhoEmMB < this.tamanhoLimite;
  }

  showAlertExtensao() {
    Swal({
      title: "Atenção",
      text: this.mensagemErroArquivoExtensao,
      type: "error",
    });
  }

  showAlertTamanhoInvalido() {
    Swal({
      title: "Atenção",
      text: this.mensagemErroArquivoTamanho,
      type: "error",
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/app-upload/app-upload.component.ts